import React, { Component } from "react";
const Rentals = () => {
  return <h1>Hello World from Rentals</h1>;
};

export default Rentals;
